<template lang="pug"></template>

<script>
export default {
    name: 'BotaoRedson',
    componentOptions: {
        title: 'Monitoramento',
        actions: [
            [
                {
                    name: 'Monitoramento',
                    iconClass: 'lyra-icon lyra-search-map',
                    showView: false,
                    action: 'abrirDashboardMonitoramentoOperacoes',
                    route: 'dashboardMonitoramento'
                }
            ]
        ]
    },

    methods: {
        abrirDashboardMonitoramentoOperacoes() {
            if (this.$route.name !== 'dashboardMonitoramento') {
                this.$router.push({ name: 'dashboardMonitoramento' });
            } else {
                this.$$router.go();
            }
        }
    }
};
</script>
